import { Avatar, AvatarGroup, Box, Button, Card, CardContent, CardHeader, Chip, Dialog, DialogContent, Divider, Grid, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, TextField, Typography } from "@mui/material"
import { MainLoggedInLayout } from "../../components/layouts/main.loggedIn.layout"
import { useContext, useEffect, useMemo, useState } from "react"
import { UserContext } from "../../context/UserContext"
import { editCommunity, getCommunity } from "../../controllers/community/community"
import { useNavigate, useParams } from "react-router"
import { QueryClient, useMutation, useQuery } from "@tanstack/react-query"
import { Add, ChevronRight, MoreVert } from "@mui/icons-material"
import MemberRequests from "../../components/community/member_requests"
import { JoinCommunityButton } from "../../components/community/join_community.button"
import { PostMedia } from "../../components/post/card/PostMedia"
import { createComment } from "../../controllers/posts/comments"
import { getSinglePost } from "../../controllers/posts/posts"
import SlimPostCard from "../../components/post/SlimPostCard"
import MembersPopUpList from "../../components/members_popup.list"
import { NoPostsIcon } from "../../components/NoPosts.Icon"
import { CategoryDisplay } from "../../components/category.display"
import { getAccount } from "../../controllers/accounts/accounts"
import { getCommunityEvents } from "../../controllers/event/event"

export const ShowCommunity = () => {
    const { id } = useParams()
    const { userDetails } = useContext(UserContext)
    let token = userDetails?.token
    
    const [media_ids, setMediaIds] = useState([])
    const [imageUrls, setImageUrls] = useState([])
    const [open, setOpen] = useState(false)
    const [members, setMembers] = useState([])
    const [membersReq, setMembersReq] = useState([])
    const [leaders, setLeaders] = useState([])
    const queryClient = new QueryClient()
    const mutationEdit = useMutation({
        mutationFn: editCommunity,
        onSuccess: () => {
        // Invalidate and refetch
        queryClient.invalidateQueries({ queryKey: ['editCommunity'] })
        setOpen(false)
        document.getElementById("status").value = ''
        setImageUrls([])
        },
    })

    const [allContent, setAllContent] = useState([])
    const { data:community, refetch } = useQuery({ queryKey: ['getSingleCommunity'], queryFn: () => getCommunity(token, id) })
    const { data:communityEvents } = useQuery({ queryKey: ['getCommunityEvents'], queryFn: () => getCommunityEvents(token, id) })

    let single_community = useMemo(()=> community?.community ?? {}, [community?.community]) 

    useEffect(() => {
        setMembers([])
        setMembersReq([])
        setLeaders([])
        if(single_community?._id === id) {
            single_community?.member?.forEach(async (member) => {
                const acct = await getAccount(member, token)
                setMembers(ids => [...ids, acct])
            })
            single_community?.member_request?.forEach(async (memberReq) => {
                const acct = await getAccount(memberReq, token)
                setMembersReq(ids => [...ids, acct])
            })
            single_community?.leader?.forEach(async (leader) => {
                const acct = await getAccount(leader, token)
                setLeaders(ids => [...ids, acct])
            })
        }
    }, [single_community, token, id])
    

    useEffect(() => {
        setAllContent([])

        const getposts = async (postID) => {
            let id = postID
            let local_post = await getSinglePost(id, token)
            // Delete record from community statuses not found
            if(local_post?.error === "Record not found"){

                editCommunity({
                    id:single_community?._id, 
                    body:{statuses:single_community?.statuses?.filter(item => item !== postID)},
                    token: userDetails?.token
                })
            }

            setAllContent(allContent => [...allContent, local_post])
        }

        single_community?.statuses?.forEach(item => getposts(item))
    }, [single_community?.statuses, token, single_community?._id, userDetails?.token])

    const mutation = useMutation({
        mutationFn: createComment,
        onSuccess: (data) => {
        // Invalidate and refetch
        queryClient.invalidateQueries({ queryKey: ['createComment'] })
        mutationEdit.mutate({
            id:single_community?._id, 
            body:{statuses:[...single_community.statuses, data.id,]},
            token:userDetails?.token
        })

        },
    })

    const send_reply = () => {
        mutation.mutate({
        body:{
            status: document.getElementById("status").value,
            visibility:"unlisted",
            media_ids
        },
        token
        })
    }

    let navigate = useNavigate()
    useEffect(() => {
        refetch()
    })

    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    const [membersOpen, setMembersOpen] = useState(false)
    const [leadersOpen, setLeadersOpen] = useState(false)

    return (
        <MainLoggedInLayout>
            <Grid 
                container 
                spacing={{ xs: 1.5, sm: 2, md: 3 }} 
                sx={{ 
                    pl: { xs: 0, sm: 2 }, 
                    pr: { xs: 1, sm: 2 },
                    '& > .MuiGrid-item': {
                        paddingLeft: { xs: '0px !important', sm: '16px !important', md: '24px !important' }
                    }
                }}
            >
                {/* Main Community Card */}
                <Grid item xs={12}>
                    <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
                        <CardHeader
                            title={<Typography variant="h5" fontWeight={700}>{single_community?.title}</Typography>}
                            subheader={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                    <Chip size="small" label={`${single_community?.member?.length || 0} members`} />
                                    <Chip size="small" variant="outlined" label={`${single_community?.statuses?.length || 0} discussions`} />
                                    <Chip size="small" variant="outlined" label={`${communityEvents?.event?.length || 0} events`} />
                                </Box>
                            }
                            action={
                                <div>
                                    {(!single_community?.member?.includes(userDetails?.id) || single_community?.leader?.includes(userDetails?.id)) &&
                                    <IconButton
                                      aria-label="more"
                                      id="long-button"
                                      aria-controls={openMenu ? 'long-menu' : undefined}
                                      aria-expanded={openMenu ? 'true' : undefined}
                                      aria-haspopup="true"
                                      onClick={handleClick}
                                    >
                                      <MoreVert />
                                    </IconButton>}
                                    <Menu
                                      id="long-menu"
                                      MenuListProps={{
                                        'aria-labelledby': 'long-button',
                                      }}
                                      anchorEl={anchorEl}
                                      open={openMenu}
                                      onClose={handleClose}
                                    >
                                        {single_community?.leader?.includes(userDetails?.id) &&
                                            <div>
                                            <MenuItem>
                                                <MemberRequests community_id={single_community?._id} members={members} requests={membersReq} />
                                            </MenuItem>
                                            <MenuItem onClick={handleClose}>
                                                <Button variant="contained" size="small" onClick={() => navigate("/community/edit/"+single_community?._id)}>Edit</Button>
                                            </MenuItem>
                                            <MenuItem onClick={handleClose}>
                                                <Button variant="contained" onClick={() => navigate("/event/create/"+single_community?._id)}>Create A Event</Button>
                                            </MenuItem>
                                            </div>
                                        }
                                        
                                        {!single_community?.member?.includes(userDetails?.id) &&
                                            <MenuItem onClick={handleClose}>
                                                <JoinCommunityButton community_details={single_community} />
                                            </MenuItem>
                                        }
                                    </Menu>
                                </div>
                            }
                        />   
                        <img
                            style={{ height: 'auto', width:"100%", maxHeight: 360, objectFit: 'cover' }}
                            alt={"community"}
                            title={single_community?.title}
                            src={single_community?.header_img}
                        />
                        <CardContent sx={{ pt: 2, px: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 3 } }}>
                            <CategoryDisplay label={single_community?.category} />
                            {!single_community?.member?.includes(userDetails?.id) && !single_community?.leader?.includes(userDetails?.id) && (
                                <Box
                                    sx={{
                                        mt: 2,
                                        p: { xs: 2, sm: 2.5 },
                                        borderRadius: 2.5,
                                        border: '1px solid',
                                        borderColor: 'primary.main',
                                        bgcolor: 'rgba(140, 141, 255, 0.08)',
                                        display: 'flex',
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        alignItems: { xs: 'flex-start', sm: 'center' },
                                        justifyContent: 'space-between',
                                        gap: 1.5,
                                    }}
                                >
                                    <Box>
                                        <Typography variant="subtitle1" fontWeight={700}>Join this community</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Connect with members, join discussions, and access community updates.
                                        </Typography>
                                    </Box>
                                    <Box sx={{ width: { xs: '100%', sm: 'auto' }, display: 'flex', justifyContent: { xs: 'stretch', sm: 'flex-end' } }}>
                                        <JoinCommunityButton community_details={single_community} />
                                    </Box>
                                </Box>
                            )}
                        </CardContent>
                    </Card>
                </Grid>

                {/* Members and Leaders Section */}
                <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%', borderRadius: 3 }}>
                        <CardContent sx={{ p: 3 }}>
                            <Typography variant="h6" fontWeight={700} gutterBottom>
                                Community People
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5 }}>Leaders</Typography>
                                    <MembersPopUpList leaders={single_community?.leader} community_id={single_community?._id} title={"Leaders List"} members={leaders} open={leadersOpen} setOpen={setLeadersOpen} />
                                    <AvatarGroup onClick={() => setLeadersOpen(true)} sx={{ justifyContent: 'flex-start', cursor: 'pointer' }} total={single_community?.leader?.length}>
                                        {leaders?.map((member, i) =>
                                            <Avatar key={i} alt="Leader" src={member.avatar} />
                                        )}
                                    </AvatarGroup>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1.5 }}>Members</Typography>
                                    <MembersPopUpList leaders={single_community?.leader} community_id={single_community?._id} title={"Members List"} members={members} open={membersOpen} setOpen={setMembersOpen} />
                                    <AvatarGroup onClick={() => setMembersOpen(true)} sx={{ justifyContent: 'flex-start', cursor: 'pointer' }} total={single_community?.member?.length}>
                                        {members?.map((member, i) =>
                                            <Avatar key={i} alt="Member" src={member.avatar} />
                                        )}
                                    </AvatarGroup>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Events Section */}
                <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%', borderRadius: 3 }}>
                        <CardContent sx={{ p: 3 }}>
                            {communityEvents?.event?.length > 0 ? (
                                <>
                                    <Typography variant="h6" fontWeight={700} gutterBottom>
                                        Upcoming Events
                                    </Typography>
                                    <Divider sx={{ mb: 1.5 }} />
                                    {communityEvents?.event?.map((event, i) =>
                                    <ListItemButton key={i} onClick={() => navigate("/event/show/"+event._id)} sx={{ borderRadius: 2, mb: 1, border: '1px solid', borderColor: 'divider', minHeight: 52 }}>
                                        <ListItem sx={{ padding: 0 }}>
                                            <ListItemText 
                                                primary={event.title}
                                                primaryTypographyProps={{ fontWeight: 600 }}
                                            />
                                        </ListItem>
                                        <ListItemIcon>
                                        <ChevronRight />
                                        </ListItemIcon>
                                    </ListItemButton>
                                    )}
                                </>
                            ) : (
                                <Box sx={{ textAlign: 'center', py: 7 }}>
                                    <Typography color="text.secondary">No upcoming events</Typography>
                                </Box>
                            )}
                        </CardContent>
                    </Card>
                </Grid>

                {/* Discussions Section */}
                <Grid item xs={12}>
                    <Card sx={{ borderRadius: 3 }}>
                        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                <Typography variant="h6" fontWeight={700} sx={{ m: 0 }}>Discussions</Typography>
                                {( single_community?.leader?.includes(userDetails?.id) || single_community?.member?.includes(userDetails?.id) ) &&
                                    <Button onClick={() => setOpen(true)} color="success" variant="contained" startIcon={<Add />} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                                        Add Post
                                    </Button>
                                }
                            </div>
                            {single_community?.statuses?.length > 0 ?
                                allContent.map((post, i) =>
                                    <SlimPostCard key={i} entity_id={single_community?._id} statuses={single_community?.statuses} content={post} token={token} />
                                )
                                :
                                <NoPostsIcon />
                            }
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Dialog
                open={open}
                onClose={() => setOpen(!open)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogContent>
                    <TextField id="status" fullWidth rows={4} multiline label='Create Post' variant="outlined" />
                    <PostMedia imageUrls={imageUrls} setImageUrls={setImageUrls} media_ids={media_ids} setMediaIds={setMediaIds} token={token} />
                    <Button onClick={send_reply} variant="contained" fullWidth sx={{ mt: 2 }}>Upload Post</Button>
                </DialogContent>
            </Dialog>
        </MainLoggedInLayout>
    )
}